import { z } from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import type { ReturnRequestDto } from "@babackapp/private-api-client/types";

const formSchema = z.object({
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  phone: z.string().optional(),
  address1: z.string().optional(),
  address2: z.string().optional(),
  country: z.object({
    name: z.string().optional(),
    code: z.string().optional(),
  }),
  province_code: z.string().optional(),
  zip: z.string().optional(),
  city: z.string().optional(),
});

export default function useEditBillingAddressForm(
  returnRequest: ReturnRequestDto,
) {
  const { billingAddress } = returnRequest;

  return useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      firstName: billingAddress.first_name ?? "",
      lastName: billingAddress.last_name ?? "",
      address1: billingAddress.address1 ?? "",
      address2: billingAddress.address2 ?? "",
      zip: billingAddress.zip ?? "",
      city: billingAddress.city ?? "",
      country: {
        name: billingAddress.country ?? "France",
        code: billingAddress.country_code ?? "Fr",
      },
      province_code: billingAddress.province_code ?? "",
      phone: billingAddress.phone ?? "",
    },
  });
}
